/**
 * Trust banner CTA — delegates to the bundle product section so the button adds
 * exactly the same lines to the cart as the main add-to-cart button, including
 * the selected variant, every bundle product and the cart drawer refresh.
 *
 * Falls back to the configured link when there is no bundle product section on
 * the page (e.g. the section is used on its own).
 */
(function () {
  function findProductSection() {
    return document.querySelector('[data-et-buy-box]');
  }

  function showError(button, message) {
    const target = button.closest('.et-sfs-trust__cta');
    const errorEl = target ? target.querySelector('[data-et-trust-error]') : null;
    if (!errorEl) return;
    errorEl.textContent = message || '';
    errorEl.hidden = !message;
  }

  function onClick(event) {
    const button = event.currentTarget;
    const fallback = button.dataset.fallbackLink;
    const product = findProductSection();

    if (!product) {
      if (fallback) window.location.href = fallback;
      return;
    }

    event.preventDefault();
    showError(button, '');

    customElements.whenDefined(product.localName).then(() => {
      if (typeof product.addToCart !== 'function') {
        if (fallback) window.location.href = fallback;
        return;
      }

      product.addToCart(button).then((result) => {
        if (result && result.ok) return;

        showError(button, (result && result.message) || '');

        // Send the visitor to the buy box so they can resolve it there
        product.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-et-trust-atc]').forEach((button) => {
      if (button.dataset.etBound === 'true') return;
      button.dataset.etBound = 'true';
      button.addEventListener('click', onClick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
